import React, { useState, useEffect } from 'react';
import "./EditarSolicitacao.css";
import { Form, Select, Button, message, Modal, Input, Table, Space, Descriptions } from 'antd';
import { DownOutlined, CarOutlined, FileTextOutlined, NumberOutlined, CalendarOutlined, TagOutlined } from '@ant-design/icons';
import api from '../../../services/api';
import veiculoService from '../../../services/veiculoService';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import API_CONFIG from '../../../config/api.config';

const { Option } = Select;

const EditarSolicitacaoPre = () => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const [solicitacao, setSolicitacao] = useState(null);
  const [solicitacaoOriginal, setSolicitacaoOriginal] = useState(null);
  const [veiculos, setVeiculos] = useState([]);
  const [veiculoSelecionado, setVeiculoSelecionado] = useState(null);
  const [itens, setItens] = useState([]);
  const [modalItemVisivel, setModalItemVisivel] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [ItemInput, setItemInput] = useState("");
  const [quantidadeInput, setQuantidadeInput] = useState("");
  const [descricaoInput, setDescricaoInput] = useState("");
  const [linhaExpandida, setLinhaExpandida] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [loadingVeiculos, setLoadingVeiculos] = useState(false);

  // Buscar dados da solicitação e veículos ao montar
  useEffect(() => {
    const idSolicitacao = location.state?.idSolicitacao;
    if (!idSolicitacao) {
      message.error('ID da solicitação não encontrado');
      navigate('/prefeitura/home');
      return;
    }

    const buscarDados = async () => {
      try {
        setLoading(true);
        // Buscar todos os dados da solicitação (incluindo itens e veículo)
        const responseItens = await api.get(API_CONFIG.ENDPOINTS.SOLICITACOES.ITENS(idSolicitacao));
        if (responseItens.data.status) {
          const dadosSolicitacao = responseItens.data.solicitacao;
          // Preencher solicitação e original
          setSolicitacao(dadosSolicitacao);
          setSolicitacaoOriginal(dadosSolicitacao);
          // Preencher itens
          if (dadosSolicitacao.itens) {
            const itensFormatados = dadosSolicitacao.itens.map(item => ({
              id: item.IT_ID,
              nomeItem: item.IT_NOME,
              quantidade: item.IT_QUANTIDADE,
              descricao: item.IT_DESCRICAO,
              status: item.IT_STATUS,
              dataVinculacao: item.IT_DATA_VINCULACAO,
              IT_COM_ID: item.IT_COM_ID
            }));
            setItens(itensFormatados);
          } else {
            setItens([]);
          }
          // Preencher veículo selecionado
          if (dadosSolicitacao.SOL_VEI_ID && dadosSolicitacao.veiculo) {
            setVeiculoSelecionado(dadosSolicitacao.SOL_VEI_ID);
          } else {
            setVeiculoSelecionado(null);
          }
        } else {
          setSolicitacao(null);
          setSolicitacaoOriginal(null);
          setItens([]);
          setVeiculoSelecionado(null);
        }
      } catch (error) {
        ////console.error('Erro ao buscar dados:', error);
        message.error('Erro ao carregar dados da solicitação');
      } finally {
        setLoading(false);
      }
    };

    buscarDados();
  }, [location.state, navigate]);

  useEffect(() => {
    const carregarVeiculos = async () => {
      try {
        setLoadingVeiculos(true);
        const idPrefeitura = localStorage.getItem('idPrefeitura');
        const response = await veiculoService.listarPorPrefeitura(idPrefeitura);

        if (response.status && response.veiculos) {
          setVeiculos(response.veiculos);
        } else {
          message.error('Erro ao carregar veículos');
        }
      } catch (error) {
        //  //console.error('Erro ao carregar veículos:', error);
        message.error('Erro ao carregar veículos');
      } finally {
        setLoadingVeiculos(false);
      }
    };

    carregarVeiculos();
  }, []);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  // Adicionar ou editar item
  const handleSalvarItem = () => {
    if (!ItemInput.trim()) {
      message.error('Informe o nome do Item.');
      return;
    }
    if (!quantidadeInput.trim()) {
      message.error('Informe a quantidade.');
      return;
    }
    if (itemEditando !== null) {
      // Editar - mantém os dados originais que não foram alterados
      const novosItens = [...itens];
      const itemOriginal = solicitacao.itens.find(item => item.IT_ID === novosItens[itemEditando].id);
      novosItens[itemEditando] = {
        id: itemOriginal.IT_ID,
        nomeItem: ItemInput,
        quantidade: quantidadeInput,
        descricao: descricaoInput !== undefined ? descricaoInput : itemOriginal.IT_DESCRICAO,
        status: itemOriginal.IT_STATUS,
        dataVinculacao: itemOriginal.IT_DATA_VINCULACAO,
        IT_COM_ID: itemOriginal.IT_COM_ID
      };
      setItens(novosItens);
    } else {
      // Adicionar novo item
      setItens([...itens, {
        nomeItem: ItemInput,
        quantidade: quantidadeInput,
        descricao: descricaoInput,
        status: 'ABERTO',
        dataVinculacao: new Date().toISOString(),
        IT_COM_ID: null
      }]);
    }
    setModalItemVisivel(false);
    setItemInput("");
    setQuantidadeInput("");
    setDescricaoInput("");
    setItemEditando(null);
  };

  // Remover item
  const handleRemoverItem = (idx) => {
    setItens(itens.filter((_, i) => i !== idx));
  };

  // Editar item
  const handleEditarItem = (idx) => {
    setItemInput(itens[idx].nomeItem);
    setQuantidadeInput(itens[idx].quantidade);
    setDescricaoInput(itens[idx].descricao || "");
    setItemEditando(idx);
    setModalItemVisivel(true);
  };

  // Adicionar novo item
  const handleAdicionarItem = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }
    setItemInput("");
    setItemEditando(null);
    setModalItemVisivel(true);
  };

  // Salvar alterações da solicitação
  const handleSalvarSolicitacao = async () => {
    const idSolicitacao = location.state?.idSolicitacao;
    const idPrefeitura = localStorage.getItem('idPrefeitura');
    const idUsuario = localStorage.getItem('idUsuario');
    const token = localStorage.getItem('token');

    if (!token) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }

    if (!idPrefeitura || !idUsuario || !idSolicitacao) {
      message.error({
        content: 'Dados necessários não encontrados. Faça login novamente.',
        duration: 6,
        style: { fontSize: '1.2rem' }
      });
      return;
    }

    // Valida se veiculoSelecionado não é nulo e possui valor
    /* if (!veiculoSelecionado || !veiculoSelecionado.value) {
       message.error('Selecione o veículo.');
       return;
     }*/

    // Monta objeto apenas com campos alterados da solicitação principal
    const camposEditados = {};
    camposEditados.SOL_VEI_ID = 1;

    // Montar array de itens para enviar (inclui novos, editados e marcados para exclusão)
    let itensParaEnviar = [];

    // 1. Itens removidos (presentes no original, mas não no atual)
    if (solicitacaoOriginal && solicitacaoOriginal.itens) {
      solicitacaoOriginal.itens.forEach(itemOriginal => {
        const itemAtual = itens.find(item => item.id === itemOriginal.IT_ID);
        if (!itemAtual) {
          // Item original removido na tela, marcar para exclusão
          itensParaEnviar.push({
            IT_ID: itemOriginal.IT_ID,
            EXCLUIR: "SIM"
          });
        }
      });
    }

    // 2. Itens novos ou editados (presentes no atual)
    itens.forEach(itemAtual => {
      if (!itemAtual.id) {
        // Novo item, adicionar com detalhes
        itensParaEnviar.push({
          IT_ID: null,
          IT_NOME: itemAtual.nomeItem,
          IT_QUANTIDADE: Number(itemAtual.quantidade),
          IT_DESCRICAO: itemAtual.descricao || '',
          IT_STATUS: itemAtual.status || 'ABERTO',
          IT_COM_ID: itemAtual.IT_COM_ID || null
        });
      } else {
        // Item existente, verificar se foi editado
        const itemOriginal = solicitacaoOriginal?.itens?.find(i => i.IT_ID === itemAtual.id);
        if (itemOriginal) {
          if (
            itemAtual.nomeItem !== itemOriginal.IT_NOME ||
            Number(itemAtual.quantidade) !== Number(itemOriginal.IT_QUANTIDADE) ||
            (itemAtual.descricao || '') !== (itemOriginal.IT_DESCRICAO || '')
          ) {
            // Item existente foi editado, adicionar com ID, COM_ID original e detalhes atualizados
            itensParaEnviar.push({
              IT_ID: itemAtual.id,
              IT_NOME: itemAtual.nomeItem,
              IT_QUANTIDADE: Number(itemAtual.quantidade),
              IT_DESCRICAO: itemAtual.descricao || '',
              IT_COM_ID: itemOriginal.IT_COM_ID
            });
          }
          // Se não foi editado e não foi removido (tratado no passo 1), não precisa enviar
        } else {
          // Este caso não deveria ocorrer em um fluxo normal (item com ID mas sem original correspondente)
          ////console.warn('Item com ID encontrado no estado atual, mas não no estado original:', itemAtual);
          // Se por algum motivo ocorrer, decidir se deve ser enviado (talvez como novo ou com ID/COM_ID nulos?)
          // Por enquanto, não vamos enviar itens nesse estado ambíguo.
        }
      }
    });


    // Se não houver campos da solicitação editados nem itens para enviar, não faz nada
    if (Object.keys(camposEditados).length === 0 && itensParaEnviar.length === 0) {
      message.info('Nenhuma alteração detectada nos campos principais ou itens.');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...camposEditados,
        itens: itensParaEnviar
      };

      // //console.log('Payload enviado:', payload); // Log para debug

      const response = await api.put(API_CONFIG.ENDPOINTS.SOLICITACOES.ATUALIZAR(idSolicitacao), payload);

      ////console.log('Resposta da API:', response.data); // Log para debug da resposta

      if (response.data.status) {
        message.success({
          content: response.data.message || 'Solicitação atualizada com sucesso!',
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
        navigate('/prefeitura/home'); // Redirecionar após sucesso
      } else {
        // Exibir mensagem de erro específica da API se disponível
        const errorMessage = response.data.message || 'Erro ao atualizar solicitação.';
        message.error({
          content: errorMessage,
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
        // Se a API retornar erros de validação detalhados, você pode adicioná-los aqui
      }
    } catch (error) {
      //console.error('Erro ao atualizar solicitação:', error.response?.data || error.message);
      const apiErrorMessage = error.response?.data?.message || 'Erro ao conectar com a API.';

      // Logar detalhes específicos do erro 422 se disponíveis
      if (error.response && error.response.status === 422 && error.response.data.errors) {
        //console.error('Detalhes do erro de validação (422):', error.response.data.errors);
        // Opcional: Formatar e exibir os erros de validação na interface, se desejar
        // Ex: const validationErrors = error.response.data.errors;
        // message.error(`Erro de validação: ${Object.values(validationErrors).join(', ')}`);
      }

      message.error({
        content: apiErrorMessage,
        duration: 6,
        style: { fontSize: '1.2rem' }
      });
    } finally {
      setLoading(false);
    }
  };

  // Colunas da tabela
  const columns = [
    {
      title: 'Nº',
      dataIndex: 'numero',
      key: 'numero',
      render: (_, __, idx) => idx + 1,
      width: 60
    },
    {
      title: 'Nome do Item',
      dataIndex: 'nomeItem',
      key: 'nomeItem',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      width: 120
    },
    {
      title: '',
      key: 'acoes',
      width: 220,
      render: (_, __, idx) => (
        <Space>
          <Button onClick={() => handleEditarItem(idx)}>Editar</Button>
          <Button danger onClick={() => handleRemoverItem(idx)}>Remover</Button>
          {/*  <Button
            type="default"
            className="visualizar-btn"
            onClick={() => {
              setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
            }}
          >
            {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
          </Button>*/}
        </Space>
      )
    }
  ];

  if (loading) {
    return (
      <div className={`editar-solicitacao-pre-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
        <div className="modal-wrapper">
          <div className="modal-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Carregando...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`editar-solicitacao-pre-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Editar Solicitação</h1>
        <div className="modal-content">
          <div className="editar-solicitacao-pre-header-box">
            <div className="editar-solicitacao-pre-header-numero">
              <FileTextOutlined style={{ fontSize: 24, color: '#001f4d' }} />
              Nº da solicitação: <span>{solicitacao?.SOL_ID || '...'}</span>
            </div>

            <div className="editar-solicitacao-pre-header-info">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label={<span><CalendarOutlined /> Data de Abertura</span>}>
                  {solicitacao?.SOL_DATA_VINCULACAO ? new Date(solicitacao.SOL_DATA_VINCULACAO).toLocaleDateString('pt-BR') : '-'}
                </Descriptions.Item>
              </Descriptions>

              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label={<span><TagOutlined /> Status</span>}>
                  {solicitacao?.SOL_STATUS || '-'}
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="editar-solicitacao-pre-header-veiculo">
              <CarOutlined style={{ fontSize: 24, color: '#001f4d' }} />
              <span className="veiculo-label" style={{ fontWeight: 600 }}>Veículo:</span>
              <Select
                style={{ width: '50%' }}
                placeholder="Selecione o veículo"
                value={veiculoSelecionado}
                onChange={setVeiculoSelecionado}
                loading={loadingVeiculos}
                suffixIcon={<DownOutlined style={{ fontSize: 16, color: '#001f4d' }} />}
              >
                {veiculos.map(veiculo => (
                  <Option key={veiculo.VEI_ID} value={veiculo.VEI_ID}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CarOutlined style={{ fontSize: 16, color: '#001f4d' }} />
                      <div>
                        <span style={{ fontWeight: 500 }}>{veiculo.VEI_DESCRICAO}</span>
                        {' '}
                        <span style={{ fontSize: '0.9em', color: '#666' }}>Placa: {veiculo.VEI_PLACA}</span>
                      </div>
                    </div>
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <Button type="primary" onClick={handleAdicionarItem} className="submit-adicionar" style={{ backgroundColor: '#008026' }}>
              Adicionar Item
            </Button>
          </div>

          {isMobile ? (
            <div className="tabela-mobile">
              {itens.map((item, idx) => (
                <div className="tabela-mobile-item" key={item.id || idx}>
                  <div className="item-nome">{item.nomeItem}</div>
                  <div className="item-quantidade">Quantidade: {item.quantidade}</div>
                  <div className="item-botoes">
                    <Button onClick={() => handleEditarItem(idx)} size="small">Editar</Button>
                    <Button danger onClick={() => handleRemoverItem(idx)} size="small">Remover</Button>
                    <Button
                      type="default"
                      className="visualizar-btn"
                      size="small"
                      onClick={() => {
                        setLinhaExpandida(linhaExpandida[0] === idx ? [] : [idx]);
                      }}
                    >
                      {linhaExpandida[0] === idx ? 'Fechar' : 'Visualizar'}
                    </Button>
                  </div>
                  {linhaExpandida[0] === idx && (
                    <>
                      {item.descricao && (
                        <div className="item-descricao">{item.descricao}</div>
                      )}
                      <div className="detalhe-expandido-item" style={{ marginTop: 8 }}>
                        <div className="col-esq">
                          <div>
                            <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                            <div className="valor-destaque">{item.nomeItem}</div>
                          </div>
                          <div>
                            <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                            <div className="valor-destaque">{item.quantidade}</div>
                          </div>
                        </div>
                        <div className="col-dir">
                          <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                          <div className="descricao-expandida">{item.descricao || '-'}</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={itens}
              pagination={false}
              rowKey={(record) => record.id || record.nomeItem}
              style={{ background: 'white', marginBottom: 24, clear: 'both' }}
              className="tabela-solicitacao"
              expandable={{
                expandedRowRender: (record) => (
                  <div className="detalhe-expandido-item">
                    <div className="col-esq">
                      <div>
                        <span className="label-icone"><FileTextOutlined /> Nome do item:</span>
                        <div className="valor-destaque">{record.nomeItem}</div>
                      </div>
                      <div>
                        <span className="label-icone"><NumberOutlined /> Quantidade:</span>
                        <div className="valor-destaque">{record.quantidade}</div>
                      </div>
                    </div>
                    <div className="col-dir">
                      <span className="label-icone"><FileTextOutlined /> Descrição:</span>
                      <div className="descricao-expandida">{record.descricao || '-'}</div>
                    </div>
                  </div>
                ),
                expandedRowKeys: linhaExpandida,
                onExpand: (expanded, record, index) => {
                  // Não faz nada aqui, pois o controle é feito pelo botão Visualizar
                },
                showExpandColumn: false
              }}
            />
          )}

          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Button type="primary" onClick={handleSalvarSolicitacao} className="submit-button" loading={loading}>
              Salvar Alterações
            </Button>
          </div>
        </div>
        <Modal
  title={itemEditando !== null ? 'Editar Item' : 'Adicionar Item'}
  open={modalItemVisivel}
  onCancel={() => {
    setModalItemVisivel(false);
    setItemEditando(null);
    setItemInput("");
    setQuantidadeInput("");
    setDescricaoInput("");
  }}
  centered
  maskClosable={false}
  destroyOnClose
  wrapClassName={isMobile ? "modal-mobile-fullscreen" : ""}
  footer={
    <div className="modal-buttons-pre">
      <Button
        danger
        onClick={() => {
          setModalItemVisivel(false);
          setItemEditando(null);
          setItemInput("");
          setQuantidadeInput("");
          setDescricaoInput("");
        }}
        style={{
          background: '#fff',
          color: '#d32f2f',
          border: '1.5px solid #d32f2f',
          height: 48,
          fontSize: '1.15rem',
          minWidth: 120
        }}
      >
        Cancelar
      </Button>
      <Button
        type="primary"
        onClick={handleSalvarItem}
        style={{
          background: 'linear-gradient(90deg, #001f4d 60%, #003380 100%)',
          color: '#fff',
          border: 'none',
          height: 48,
          fontSize: '1.15rem',
          minWidth: 120
        }}
      >
        Salvar
      </Button>
    </div>
  }

        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Nome do Item *</label>
              <Input
                placeholder="Nome do Item"
                value={ItemInput}
                onChange={e => setItemInput(e.target.value)}
                maxLength={100}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Quantidade/Litros *</label>
              <Input
                placeholder="Quantidade/Litros"
                value={quantidadeInput}
                onChange={e => setQuantidadeInput(e.target.value)}
                type="number"
                min="1"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Descrição</label>
              <Input.TextArea
                placeholder="Descrição do item"
                value={descricaoInput}
                onChange={e => setDescricaoInput(e.target.value)}
                maxLength={500}
                rows={4}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default EditarSolicitacaoPre;